import { AnyAction } from 'redux'
import { useEffect, useReducer } from 'react'
import { GET_USERINFO } from '../../api/System_Api'
import { getUserId } from '../../tools/util'
// action 类型定义
const ALLOCATIONADD_ACTION_TYPE = {
  SET_USERINFOL: 'ALLOCATIONADD/SET_USERINFOL', // 设置个人信息
}

interface UserInfo {
  userInfo: {
    id: string
    mail: string
    name: string
    phone: string
    realName: string
    password?: string
  }
}
type AllocationAddState = UserInfo
// 默认数据
const defaultState: AllocationAddState = {
  userInfo: {
    id: '',
    mail: '',
    name: '',
    phone: '',
    realName: '',
  },
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case ALLOCATIONADD_ACTION_TYPE.SET_USERINFOL:
      arr.userInfo = action.value
      return arr
    default:
      return state
  }
}
// 设置个人数据
const setUserInfoAction = (param: UserInfo) => ({
  type: ALLOCATIONADD_ACTION_TYPE.SET_USERINFOL,
  value: param,
})
const useMemberinfoHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)
  const { userInfo } = statepages

  useEffect(() => {
    getUser()
  }, [])

  const getUser = async () => {
    const data = await GET_USERINFO({
      supplierUserId: getUserId(),
    })
    dispatch(setUserInfoAction(data.data))
  }
  return {
    userInfo,
  }
}

export default useMemberinfoHooks
import { AnyAction } from 'redux'
import { useEffect, useReducer } from 'react'
import { GET_USERINFO } from '../../api/System_Api'
import { getUserId } from '../../tools/util'
// action 类型定义
const ALLOCATIONADD_ACTION_TYPE = {
  SET_USERINFOL: 'ALLOCATIONADD/SET_USERINFOL', // 设置个人信息
}

interface UserInfo {
  userInfo: {
    id: string
    mail: string
    name: string
    phone: string
    realName: string
    password?: string
  }
}
type AllocationAddState = UserInfo
// 默认数据
const defaultState: AllocationAddState = {
  userInfo: {
    id: '',
    mail: '',
    name: '',
    phone: '',
    realName: '',
  },
}
// 默认 Reducer
const reducer = (state = defaultState, action: AnyAction) => {
  const arr = { ...state }
  switch (action.type) {
    case ALLOCATIONADD_ACTION_TYPE.SET_USERINFOL:
      arr.userInfo = action.value
      return arr
    default:
      return state
  }
}
// 设置个人数据
const setUserInfoAction = (param: UserInfo) => ({
  type: ALLOCATIONADD_ACTION_TYPE.SET_USERINFOL,
  value: param,
})
const useMemberinfoHooks = () => {
  const [statepages, dispatch] = useReducer(reducer, defaultState)
  const { userInfo } = statepages

  useEffect(() => {
    getUser()
  }, [])

  const getUser = async () => {
    const data = await GET_USERINFO({
      supplierUserId: getUserId(),
    })
    dispatch(setUserInfoAction(data.data))
  }
  return {
    userInfo,
  }
}

export default useMemberinfoHooks
